import fr from 'facet-rest';

export const accountHistoryTitleGenerator = () => resource => resource.attr('name');

export const AccountHistoryOverride = fr.metaOverride()
  .nameOverride('updatedAt', { _titleGenerator: accountHistoryTitleGenerator });
